import { ChainId, Token, WETH } from "../../../libs/uniswap";
import { convert41to0x } from "../../../utils/tronweb/utils";
export const TronAddresses = {
    TOKEN_RING: "416e0d26adf5323f5b82d5714354dc3c6870adee7c",
    TOKEN_KTON: "41dc3e713213d0403f82addbfb66b8574b86851c19",
    TOKEN_WETH: "",
    ELEMENT_GOLD: "4117ff7d2060e2f91b6cbc0b4b335c1d37cd8861f5",
    ELEMENT_WOOD: "414c0a6059688ff86c4bfd88312bceb4e0e050b078",
    ELEMENT_WATER: "4186f29de0e912e4ffdabc6de1b9666fa8d63b66a7",
    ELEMENT_FIRE: "41ba6c9bf5cd0b9209a4ac0c82b53f6cbe4fff5623",
    ELEMENT_SOIL: "41a0002398fcf33c6fa50206751f70f2f8f553fe58",
    GOLD_RUSH_RAFFLE: "41088303DC5304E273A5A838B4BB9B9645D737EE0E",
    PVETEAM_PROXY: "",
    MATERIAL_PROXY: "",
    MATERIALTAKEBACK_PROXY: "",
    CRAFTBASE_PROXY: "",
    LAND_CLOCK_AUCTION: "4176cb443f8280d28d6f84531a92c1330dd3203fdb",
    APOSTLE_CLOCK_AUCTION: "41d80524bd98439612184c481cc6a6a3608491551f",
    SIRING_CLOCK_AUCTION: "41f80ba670704296752b1a3c8f17ff17e24bc7234e",
    APOSTLE_BASE: "416af8a99d0539ac273ef92b13b0edefedfcf51bc8",
    LAND_RESOURCE: "41f738cb701d94a35352621de20bc48ba598ae142e",
    TOKEN_USE: "41ca9d92d82e7a4054f9dee7e8c6b4451cfff3c87d",
    OBJECTOWNERSHIP: "4100dfe66a889aa22228e7b17236ceb7e6d3b286b2",
    SETTINGSREGISTRY: "411CD4EDBEC62F4BC43FFA3C6A58779242E82282E7",
    POINTS_REWARD_POOL: "41d067d15418edcd7ba2da26589bdc2bf961e640dc",
    TOKEN_USER_POINTS: "41b580669bb5b33a97267861d1176fe412a800f791",
    FURNACE_TREASURE: "",
    FURNACE_ITEM_BASE: "",
    FURNACE_TAKEBACK: "",
    UNISWAP_EXCHANGE: "41394CFB02DA445B95CA61DB8A993AF63E2AAE907A",
    STAKINGREWARDSFACTORY: "",
    GOLDRAFFLEPOOL_PROXY: "",
    WOODRAFFLEPOOL_PROXY: "",
    WATERRAFFLEPOOL_PROXY: "",
    FIRERAFFLEPOOL_PROXY: "",
    SOILRAFFLEPOOL_PROXY: "",
};
export const TronTokens = {
    RING: new Token(ChainId.TRON, convert41to0x(TronAddresses.TOKEN_RING), 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.TRON, convert41to0x(TronAddresses.TOKEN_KTON), 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.TRON, convert41to0x(TronAddresses.ELEMENT_GOLD), 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.TRON, convert41to0x(TronAddresses.ELEMENT_WOOD), 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.TRON, convert41to0x(TronAddresses.ELEMENT_WATER), 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.TRON, convert41to0x(TronAddresses.ELEMENT_FIRE), 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.TRON, convert41to0x(TronAddresses.ELEMENT_SOIL), 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.TRON],
};
